/*eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  customerList: [],
  selectedCustomer : null
};

const customerSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    setCustomers: (state, action) => {
      state.customerList = action.payload;
    },
    updateCustomer: (state, action) => {
      const { id, data } = action.payload;
      const index = state.customerList.findIndex(cust => cust.pk === id);
      if (index !== -1) {
        state.customerList[index] = { ...state.customerList[index], ...data };
      }
      },
    setSelectedCustomer : (state,action) => {
      state.selectedCustomer = action.payload
    },
    clearSelectedCustomer : (state) => {
        state.selectedCustomer = null;
    }
  },
});

export const { setCustomers,setSelectedCustomer, clearSelectedCustomer ,updateCustomer} = customerSlice.actions;
export default customerSlice.reducer;
